import { ref, computed, watch } from 'vue'
import { type ResType } from '@api-client/typeUtils';
import { deliveryteamOrdersApiClient } from '@api-client/deliveryteam_orders';
import { authState, waitUntilReady } from '@/ui-plus/useAuth';
import { initCourierActiveOrders, refreshRecentOrderIds, stopAutoRefreshRecentOrderIds } from './RecentOrders';
import { listenCourierNotifier } from '@deliveryteam-spa-orders-vue/utils/listenCourierNotifier';

export type deliveryteamListType = ResType<
    typeof deliveryteamOrdersApiClient.my_order_deliveryteams.$post
>["data"];

export const myDeliveryteams = ref<deliveryteamListType>([]);
export const isMyDeliveryteamsLoading = ref(true);

export const searchQuery = ref('')
export const myDeliveryteamsFiltered = computed(() =>
    myDeliveryteams.value.filter(deliveryteam =>
        deliveryteam.name.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
        deliveryteam.address1?.toLowerCase().includes(searchQuery.value.toLowerCase())
    ).sort((a) => {
        return a.isUserActivatedTeam ? -1 : 1;
    })
)

export const activeDeliveryteams = computed(() => myDeliveryteams.value.filter(deliveryteam => deliveryteam.isUserActivatedTeam))

export const deliveryteamsWithNegativeBalance = computed(() => myDeliveryteams.value.filter(deliveryteam => deliveryteam.hasNegativeBalance))

export async function loadMyDeliveryteams() {
    isMyDeliveryteamsLoading.value = true;
    const response = await (await deliveryteamOrdersApiClient.my_order_deliveryteams.$post()).json()
    if (response.error) {
        console.error(response.error)
        return
    } else {
        myDeliveryteams.value = response.data.sort((
            a,
            // _b
        ) => {
            return a.isUserActivatedTeam ? -1 : 1;
        });

        listenCourierNotifier();
        // setTimeout(() => {
        initCourierActiveOrders();
        // }, 2000);

        for (const deliveryteam of myDeliveryteams.value) {
            if (deliveryteam.isUserActivatedTeam) {
                await refreshRecentOrderIds(deliveryteam.id);
            } else {
                stopAutoRefreshRecentOrderIds(deliveryteam.id);
            }
        }
    }
    isMyDeliveryteamsLoading.value = false;
}


waitUntilReady.then(() => {
    setTimeout(() => {
        watch(authState, (newState) => {
            if (newState && newState.accessTokenPayload !== null) {
                loadMyDeliveryteams();
            }
        }, { immediate: true });
    }, 1000);
});
